import type { DtoOrderOrderTypeEnum } from '@repo/api-types/order-retrieval';
import type { AssetType } from '@repo/types/asset';

import { getAppConfig } from '@/utils/window.utils';

import { isFeatureEnabled } from './feature';

interface QuestionnaireFeatureContext {
    assetType?: AssetType | undefined;
    orderType?: DtoOrderOrderTypeEnum | undefined;
    assetStatus?: string | undefined;
}

export const isQuestionnaireEnabled = (context: QuestionnaireFeatureContext): boolean => {
    return isQuestionnaireReadEnabled(context);
};

export const isQuestionnaireReadEnabled = (context: QuestionnaireFeatureContext): boolean => {
    return isFeatureEnabled(getAppConfig().feature.questionnaire?.read, context);
};

export const isQuestionnaireWriteEnabled = (context: QuestionnaireFeatureContext): boolean => {
    return isFeatureEnabled(getAppConfig().feature.questionnaire?.write, context);
};
